import {useQuery} from '@tanstack/react-query';
import {getFaqMainCategoryId} from '@/api/help/faq';

export const useGetFaqMainCategoryId = (subCategory: string) => {
  return useQuery({
    queryKey: ['help', 'faq', 'mainCategory', subCategory],
    queryFn: () => getFaqMainCategoryId(subCategory),
    select: (data) => data.data.node.parentId,
    enabled: !!subCategory,
  });
};
